import { FiAlertCircle } from 'react-icons/fi'

import { IconPencil } from '@vtex/shoreline'
import { t } from 'i18next'

import { Button } from '~/components/Buttons'
import Tooltip from '~/components/Tooltip'
import { formatMoney, isPublisher } from '~/helpers'

import * as S from './styles'

type ViewCostProps = {
  value: number
  showMinBadge: boolean
  canEdit: boolean
  onRequestEdit: () => void
  type: 'cpc' | 'cpm'
}

export const ViewCost = ({
  value,
  showMinBadge,
  canEdit,
  onRequestEdit,
  type
}: ViewCostProps) => (
  <S.Value>
    <p>{formatMoney(Number(value))}</p>

    {!isPublisher() && (
      <>
        {showMinBadge && (
          <Tooltip
            icon={<FiAlertCircle className="alert" />}
            text={t(
              `rm:components.editBudget.edit${type.toUpperCase()}.belowMinimumValue`
            )}
          />
        )}

        {canEdit && (
          <Button
            template="transparentPrimary"
            onClick={onRequestEdit}
            size="xsmall"
            text={<IconPencil width={12} height={12} />}
          />
        )}
      </>
    )}
  </S.Value>
)
